import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export function initTestimonials() {
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=split-banner",
			testimonials
		);
	}
}

export function testimonials() {
	if (!document.querySelectorAll(".testimonials-swiper").length) return false;

	const swiper = new Swiper(".testimonials-swiper", {
		modules: [Autoplay],
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: true,
		},
	});
}
